import React from "react";
import "./App.css";
import SmokeRavenNavbar from "./js/components/Navigation";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <SmokeRavenNavbar />
      </div>
    </AuthProvider>
  );
}

export default App;
